import GqlClient from 'utils/graphqlService';
import { gql } from '@apollo/client';
import _get from 'lodash/get';
const GetEmbeddedUrlByShortName = gql`
  query Widget($shortName: String) {
    widgetsCollection(
      where: { type: "embedded", client: { shortName: $shortName } }
    ) {
      items {
        widgetUrl
      }
    }
  }
`;
const getEmbeddedUrlByShortName = async (_, shortName) => {
  const { data } = await GqlClient.query({
    query: GetEmbeddedUrlByShortName,
    variables: {
      shortName,
    },
  });
  return _get(data, 'widgetsCollection.items.0.widgetUrl', []);
};

export default getEmbeddedUrlByShortName;
